import { render, staticRenderFns } from "./RankRules.vue?vue&type=template&id=f3d9dac2&"
import script from "./RankRules.vue?vue&type=script&lang=js&"
export * from "./RankRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports